import useResetNotificationsOnSingOut from './useResetNotificationsOnSingOut';
import { useAccountNotifications } from './useAccountNotifications';
import { useTradeBustNotifications } from './useTradeBustNotifications';
import { useTradeNotifications } from './useTradeNotifications';
import { useLiquidationHistoryNotifications } from './useLiquidationHistoryNotifications';

export function GlobalNotifications() {
  useResetNotificationsOnSingOut();
  useTradeNotifications();
  useAccountNotifications();
  useTradeBustNotifications();
  useLiquidationHistoryNotifications();

  return null;
}
